<div class={$$props.class + " crtw-w-full crtw-mx-auto crtw-my-0"}>
  <slot />
</div>
